var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClipboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 611,
    height: 820,
    viewBox: "0 0 611 820",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 546,
    y: 259,
    width: 4,
    height: 124,
    rx: 2,
    fill: "#D9D9D9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 130,
    width: 611,
    height: 690,
    rx: 10,
    fill: "#CE838F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M347.354 24.5009C336.484 9.29131 321.957 0 306 0C290.043 0 275.517 9.2913 264.646 24.5009C276.348 14.7339 290.61 9 306 9C321.39 9 335.652 14.7339 347.354 24.5009Z",
    fill: "white",
    fillOpacity: 0.15
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49 151C49 149.343 50.3431 148 52 148H558C559.657 148 561 149.343 561 151V794C561 796.761 558.761 799 556 799H54C51.2386 799 49 796.761 49 794V151Z",
    fill: "#E5E5E5",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49 151C49 149.343 50.3431 148 52 148H558C559.657 148 561 149.343 561 151V787C561 789.761 558.761 792 556 792H54C51.2386 792 49 789.761 49 787V151Z",
    fill: "#E5E5E5",
    fillOpacity: 0.7
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49 151C49 149.343 50.3431 148 52 148H558C559.657 148 561 149.343 561 151V779C561 781.761 558.761 784 556 784H54C51.2386 784 49 781.761 49 779V151Z",
    fill: "#E5E5E5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M49 151C49 149.343 50.3431 148 52 148H558C559.657 148 561 149.343 561 151V771C561 773.761 558.761 776 556 776H54C51.2386 776 49 773.761 49 771V151Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M367 101C366.863 101 366.753 100.885 366.761 100.748C366.919 98.0309 367 95.2797 367 92.5C367 41.4137 339.689 0 306 0C272.311 0 245 41.4137 245 92.5C245 95.2797 245.081 98.0309 245.239 100.748C245.247 100.885 245.137 101 245 101C238.493 101 232.106 104.75 225.719 108.5C219.331 112.25 212.944 116 206.437 116H160C140.67 116 125 131.67 125 151V153V170H486V153V151C486 131.67 470.33 116 451 116H405.563C399.056 116 392.669 112.25 386.281 108.5C379.894 104.75 373.507 101 367 101ZM305.5 102C322.345 102 336 88.3447 336 71.5C336 54.6553 322.345 41 305.5 41C288.655 41 275 54.6553 275 71.5C275 88.3447 288.655 102 305.5 102Z",
    fill: "#D9D9D9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M125 165H486V175C486 176.657 484.657 178 483 178H128C126.343 178 125 176.657 125 175V165Z",
    fill: "#AEAAAA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M305.5 102C322.345 102 336 88.3447 336 71.5C336 70.7804 335.975 70.0667 335.926 69.3596C334.828 83.1275 321.625 94 305.5 94C289.375 94 276.172 83.1275 275.074 69.3596C275.025 70.0667 275 70.7804 275 71.5C275 88.3447 288.655 102 305.5 102Z",
    fill: "#AEAAAA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboard);
export default __webpack_public_path__ + "static/media/clipboard.21c09f4b1556130f20724c24f025c7a8.svg";
export { ForwardRef as ReactComponent };